export default __webpack_public_path__ + "static/media/maki1@3x.b050ef96.png";